import { WhatsappTemplateCategory, WhatsappTemplateStatus } from '../types/whatsappTemplates';

export type TemplatesFilterChip = 'All' | 'Marketing' | 'Utility' | 'Authentication';
export type TemplatesViewMode = 'cards' | 'table';

export const STATUS_STYLES: Record<WhatsappTemplateStatus, string> = {
  approved: 'bg-emerald-100 text-emerald-700',
  inReview: 'bg-amber-100 text-amber-700',
  rejected: 'bg-rose-100 text-rose-700',
  draft: 'bg-slate-100 text-slate-700',
  pending: 'bg-gray-100 text-gray-700',
};

export const CATEGORY_STYLES: Record<WhatsappTemplateCategory, string> = {
  marketing: 'bg-green-50 text-green-700',
  utility: 'bg-yellow-50 text-yellow-700',
  authentication: 'bg-blue-50 text-blue-700',
};

export const FILTER_TO_CATEGORY: Record<Exclude<TemplatesFilterChip, 'All'>, WhatsappTemplateCategory> = {
  Marketing: 'marketing',
  Utility: 'utility',
  Authentication: 'authentication',
};

export const STATUS_LABELS_KEYS: Record<WhatsappTemplateStatus, any> = {
  approved: 'whatsappTemplates.statuses.approved',
  inReview: 'whatsappTemplates.statuses.inReview',
  rejected: 'whatsappTemplates.statuses.rejected',
  draft: 'whatsappTemplates.statuses.draft',
  pending: 'whatsappTemplates.statuses.inReview',
};

export const CATEGORY_LABELS_KEYS: Record<WhatsappTemplateCategory, any> = {
  marketing: 'whatsappTemplates.categories.marketing',
  utility: 'whatsappTemplates.categories.utility',
  authentication: 'whatsappTemplates.categories.authentication',
};
